import { ActionPayroll } from '../../pages';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';
import { PayrollController } from '../../controllers';
import { object, string } from 'yup';

const ActionPayrollContainer = ({ closeModal }) => {
	const [viewBreakdown, setViewBreakdown] = useState(false);
	const [loading, setLoading] = useState(false);
	const showPayrollBreakdown = () => {
		setViewBreakdown(true);
	};

	const payload = JSON.parse(localStorage.getItem(constant.RouteParams));

	const validationSchema = () => {
		return object({
			comment: string().required('Please enter comment'),
		});
	};
	const onSubmit = async (data) => {
		setLoading(true)
		localStorage.setItem(constant.RouteParams, JSON.stringify({}));
		delete payload.all;
		delete payload.details;
		const { status, errorMessage } = await PayrollController.setIgnoreOrPending({
			ids: payload.ids,
			comment: data.comment,
			status: payload.status
		});
		if(status === constant.Success) {
			setLoading(false)
			MimaToastUtil.success({
				message: constant.Success
			});
			localStorage.setItem(constant.RouteParams, JSON.stringify({}));
			return closeModal();
		}
		localStorage.setItem(constant.RouteParams, JSON.stringify({}));
		setLoading(false)
		 MimaToastUtil.error({
			message: errorMessage
		});
		closeModal();
	}


	return (
		<ActionPayroll
			closeModal={closeModal}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			viewBreakdown={viewBreakdown}
			showPayrollBreakdown={showPayrollBreakdown}
			details={payload}
			loading={loading}
		/>
	);
};

export default observer(ActionPayrollContainer);
